import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectorRef, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup, FormGroupDirective, UntypedFormControl } from '@angular/forms';
import { CalculationService } from '../../service/calculation.service';
import { interval, Observable, merge, Subject } from 'rxjs';
import { debounce, first, map } from 'rxjs/operators';
import { FUERWENOPTIONS$, FUERWENOPTIONSEXPERT$ } from './calculaters.component.data';
import { OffertComponent } from '../offert/offert.component';
import { IRsOffert } from '../../models/rsoffert';
import { OffertService } from '../../service/offert.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PopupService } from '../../service/popup.service';
import { MessageService } from '../../service/message.service';
import { ActivatedRoute } from '@angular/router';
import { IRsProdukt } from '../../models/rsprodukt';
import { TranslateService } from '@ngx-translate/core';
import { IRsLeistungsuebersicht } from '../../models/rsleistungsuebersicht';
import { IRsPaket } from '../../models/rspaket';
import { PraemienStatus } from '../../../shared/praemie';
import { AntragComponent } from '../antrag/antrag.component';
import { RsAntragComponent } from '../antrag/rs-antrag/rs-antrag.component';
import { IRsAntrag } from '../../models/rsantrag';
import { AntragService } from '../../service/antrag.service';
import { RsZusammenfassungComponent } from '../zusammenfassung/rs-zusammenfassung/rs-zusammenfassung.component';
import { MatLegacyListOption as MatListOption } from '@angular/material/legacy-list';
import {
  valueChanges, toggleEditMode, getExpertMode, getQuery, getOffertBaseId,
  getOffertBase, getPartnerId, getPartner, getVerifyOffert, getOffertAntrag
} from '../../../shared/utils';
import { CurrencyService } from '../../service/currency.service';
import { AntragWeitereFragenComponent } from '../antrag/antrag-weitere-fragen/antrag-weitere-fragen.component';
import { VereinbarungKommunikationComponent } from '../vereinbarung-kommunikation/vereinbarung-kommunikation.component';
import { DatenschutzPolicyComponent } from '../datenschutz-policy/datenschutz-policy.component';
import { DateService } from '../../service/date.service';
import { CurrentRechner } from '../../../shared/rechner';
import { DatenBeratungsprotokollComponent } from '../daten-beratungsprotokoll/daten-beratungsprotokoll.component';
import { OffertBaseService } from '../../service/offert.base.service';
import { ILookupValue } from '../../models/lookupvalues';
import { OffertVerificationDialogService } from '../../service/offert-verification-dialog.service';
import { DataService } from '../../service/data.service';
import { LookupService } from '../../service/lookup.service';
import { CustomValidator } from '../../../shared/validation';
import { ProduktArt, ErrorMessageType } from '../../../shared/enum';
import { ProcessingService } from '../../service/processing.service';
import * as moment from 'moment';
import { IRsResult } from '../../models/rsresult';
import { FriendlycaptchaWidgetComponent } from '../friendlycaptcha-widget/friendlycaptcha-widget.component';
import { CalculateComponent } from '../calculate/calculate.component';

@Component({
  selector: 'app-calculaters',
  templateUrl: './calculaters.component.html',
  styleUrls: ['./calculaters.component.scss'],
})
export class CalculateRsComponent extends CalculateComponent implements OnInit, AfterViewInit {

  @ViewChild('firstFormGroupDirective') firstFormGroupDirective: FormGroupDirective;
  @ViewChild('secondFormGroupDirective') secondFormGroupDirective: FormGroupDirective;
  @ViewChild('thirdFormGroupDirective') thirdFormGroupDirective: FormGroupDirective;
  @ViewChild('fourthFormGroupDirective') fourthFormGroupDirective: FormGroupDirective;
  @ViewChild('fifthFormGroupDirective') fifthFormGroupDirective: FormGroupDirective;

  @ViewChildren('angebotTeaser', { read: ElementRef }) angebotTeaserList: QueryList<ElementRef>;
  @ViewChildren('antragTeaser', { read: ElementRef }) antragTeaserList: QueryList<ElementRef>;

  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;
  thirdFormGroup: UntypedFormGroup;
  fourthFormGroup: UntypedFormGroup;
  fifthFormGroup: UntypedFormGroup;

  submitted = false;
  kuendigungRisiken = false;
  korrektur = false;

  leistungsuebersicht$: Observable<IRsLeistungsuebersicht>;
  fuerWenOptions$: Observable<ILookupValue[]>;
  versicherungssumme = '€ 100.000,-';
  paket: IRsPaket;

  rsResult: IRsResult;

  expertMode: boolean;
  offertBaseId: number;
  offertBase: boolean;
  partnerId: number;
  partner: boolean;
  verifyOffert: boolean;
  offertAntrag: boolean;

  geburtsdatumDisabled = false;

  calculateRate$ = new Subject();
  createOffert$ = new Subject();
  createAntrag$ = new Subject();

  produktArt = ProduktArt;

  beginndatumMinDate: Date;
  beginndatumMaxDate: Date;

  antragVersicherungsnehmer: UntypedFormGroup;
  offertVersicherungsnehmer: UntypedFormGroup;

  fuerWenOptions: Map<number, string> =
    new Map([
      [1, 'Für mich'],
      [2, 'Für mich und meine Kinder'],
      [3, 'Für mich, meine/n Ehepartner/in, Lebensgefährten/in und Kinder']
    ]);

  fuerWenOptionsExpert: Map<number, string> =
    new Map([
      [1, 'Versicherungsnehmer/in'],
      [2, 'Versicherungsnehmer/in und ihre/seine Kinder'],
      [3, 'VN, Ehepartner/in, Lebensgefährt/in und Kinder']
    ]);

  @ViewChild(OffertComponent) offertComponent: OffertComponent;
  @ViewChild(AntragComponent) antragComponent: AntragComponent;
  @ViewChild(RsAntragComponent) rsAntragComponent: RsAntragComponent;
  @ViewChild(RsZusammenfassungComponent) rsZusammenfassungComponent: RsZusammenfassungComponent;

  @ViewChild('thirdFormGroupFriendlycaptchaWidget') thirdFormGroupFriendlycaptchaWidgetComponent: FriendlycaptchaWidgetComponent;
  @ViewChild('fifthFormGroupFriendlycaptchaWidget') fifthFormGroupFriendlycaptchaWidgetComponent: FriendlycaptchaWidgetComponent;

  constructor(private route: ActivatedRoute, private fb: UntypedFormBuilder, private calculationService: CalculationService, private offertService: OffertService,
    private antragService: AntragService, public popupService: PopupService, public translateService: TranslateService, private praemienStatus: PraemienStatus,
    public currencyService: CurrencyService, private ref: ChangeDetectorRef, private dateService: DateService, private currentRechner: CurrentRechner,
    private offertBaseService: OffertBaseService, private offertVerificationDialogService: OffertVerificationDialogService, public dataService: DataService,
    public lookupService: LookupService, private messageService: MessageService, private processingService: ProcessingService) {

    super();

    this.expertMode = getExpertMode(this.route);
    this.offertBaseId = getOffertBaseId(this.route);
    this.offertBase = getOffertBase(this.route);
    this.partnerId = getPartnerId(this.route);
    this.partner = getPartner(this.route);
    this.verifyOffert = getVerifyOffert(this.route);
    this.offertAntrag = getOffertAntrag(this.route);

    this.beginndatumMinDate = dateService.getVertragsBeginnDatumMinDate(this.expertMode);
    this.beginndatumMaxDate = dateService.getVertragsBeginnDatumMaxDate();

    this.calculateRate$
      .pipe(debounce(() => interval(300)))
      .subscribe(() => {
        this.calculateRate();
      });

    this.createOffert$
      .pipe(debounce(() => interval(300)))
      .subscribe(() => {
        this.createOffert();
      });

    this.createAntrag$
      .pipe(debounce(() => interval(300)))
      .subscribe(() => {
        this.createAntrag();
      });

    this.currentRechner.setRechner('Rechtsschutzrechner');
    this.currentRechner.setProduktseite('https://www.hdi.at/privat/produkte/rechtsschutzversicherung.php');

    this.offertVerificationDialogService.loadOffert$
      .subscribe((data) => {
        const offert = data as IRsOffert;
        this.setProdukt(offert.Produkt);
        this.ref.detectChanges();
        this.antragComponent.versicherungsnehmerComponent.setPartner(offert.Versicherungsnehmer);
        this.offertComponent.versicherungsnehmerComponent.formGroup.patchValue(offert.Versicherungsnehmer);
        if (!this.expertMode) {
          this.popupService.openOffertAntragInfoPopup(
            offert.Versicherungsnehmer, offert.Anlagedatum, 'Rechtsschutzversicherung');
        }
      });

    this.fuerWenOptions$ = this.expertMode ? FUERWENOPTIONSEXPERT$ : FUERWENOPTIONS$;
  }

  ngOnInit() {
    this.firstFormGroup = this.fb.group({
      beginndatum: new UntypedFormControl('', Validators.required),
      paketId: new UntypedFormControl('', Validators.required),
      fuerWen: new UntypedFormControl('', Validators.required),
      deckungsumfangErhoehen: new UntypedFormControl('', Validators.required),
      berufAusschluss: new UntypedFormControl('', [Validators.required, CustomValidator.requiredNo]),
      kennzeichen: new UntypedFormControl('', [Validators.required, CustomValidator.validateKennzeichen])
    });
    this.secondFormGroup = this.fb.group({
      zahlungsArtId: new UntypedFormControl('', Validators.required),
    });
    this.thirdFormGroup = this.fb.group({
      offert: OffertComponent.createFormGroup(this.fb, this.expertMode),
      vereinbarungKommunikation: VereinbarungKommunikationComponent.createVereinbarungKommunikation(),
      datenschutzPolicy: DatenschutzPolicyComponent.createDatenschutzPolicy()
    });
    this.fourthFormGroup = this.fb.group({
      antrag: AntragComponent.createFormGroup(this.fb, this.expertMode),
      datenBeratungsprotokoll: DatenBeratungsprotokollComponent.createFormGroup(this.fb),
      antragWeitereFragen: AntragWeitereFragenComponent.createFormGroup(this.fb)
    });
    this.fifthFormGroup = this.fb.group({
      rsZusammenfassung: RsZusammenfassungComponent.createFormGroup(this.fb)
    });

    this.ref.detectChanges();

    this.onValueChanged();
    this.toggleEditMode();

    this.leistungsuebersicht$ = this.calculationService.getLeistungsuebersicht();

    if (this.offertBase) {
      this.loadOffertBase();
    } else if (this.verifyOffert) {
      this.verifyOffertLink();
    } else {
      this.beginndatum.setValue(moment(this.dateService.today()));
      if (this.expertMode) {
        this.deckungsumfangErhoehen.setValue('ja');
        this.dataService.zahlungsarten.pipe(first()).toPromise().then((zahlungsarten) => {
          this.zahlungsArtId.setValue(zahlungsarten.find(x => x.Id === '1'));
        });
      }
    }

    this.antragVersicherungsnehmer = this.antragComponent?.versicherungsnehmerComponent.formGroup;
    this.offertVersicherungsnehmer = this.offertComponent?.versicherungsnehmerComponent.formGroup;
  }

  ngAfterViewInit() {
    this.angebotTeaserList.changes.subscribe(() => {
      if (this.angebotTeaserList.length > 0) {
        (this.angebotTeaserList.first.nativeElement as HTMLElement).scrollIntoView();
      }
    });
    this.antragTeaserList.changes.subscribe(() => {
      if (this.antragTeaserList.length > 0) {
        (this.antragTeaserList.first.nativeElement as HTMLElement).scrollIntoView();
      }
    });


  }

  get beginndatum() { return this.firstFormGroup.get('beginndatum'); }
  get paketId() { return this.firstFormGroup.get('paketId'); }
  get fuerWen() { return this.firstFormGroup.get('fuerWen'); }
  get deckungsumfangErhoehen() { return this.firstFormGroup.get('deckungsumfangErhoehen'); }
  get kennzeichen() { return this.firstFormGroup.get('kennzeichen'); }
  get berufAusschluss() { return this.firstFormGroup.get('berufAusschluss'); }
  get zahlungsArtId() { return this.secondFormGroup.get('zahlungsArtId'); }
  get offert() { return this.thirdFormGroup.get('offert'); }
  get vereinbarungKommunikationOffert() { return this.thirdFormGroup.get('vereinbarungKommunikation'); }
  get datenschutzPolicyOffert() { return this.thirdFormGroup.get('datenschutzPolicy'); }
  get antrag() { return this.fourthFormGroup.get('antrag'); }
  get datenBeratungsprotokoll() { return this.fourthFormGroup.get('datenBeratungsprotokoll'); }
  get antragWeitereFragen() { return this.fourthFormGroup.get('antragWeitereFragen'); }
  get rsZusammenfassung() { return this.fifthFormGroup.get('rsZusammenfassung'); }

  get showWeitereWohneinheiten() {
    return this.paket && this.paket.WeitereWohneinheiten === true;
  }
  get paket1() {
    return this.paketId.value === 1 ? true : false;
  }
  get showKennzeichen() {
    return this.paket1;
  }

  get showAngebotTeaser() {
    return this.pdfDataOffert && this.firstFormGroup.valid && this.secondFormGroup.valid && this.thirdFormGroup.valid;
  }

  get showAntragTeaser() {
    return this.pdfDataAntrag && this.firstFormGroup.valid && this.secondFormGroup.valid && this.fourthFormGroup.valid &&
      this.fifthFormGroup.valid;
  }

  get showWeiter() {
    return this.berufAusschluss.value !== 'ja';
  }

  toggleEditMode(): void {
    toggleEditMode(this.kennzeichen, this.showKennzeichen);
  }

  loadOffertBase(): void {
    this.offertBaseService.getOffertBase(getQuery(), this.offertBaseId).subscribe(
      data => {
        if (data.LinkIsValid) {
          const offertBase = data.OffertBase;
          if (offertBase.Antrag === true) {
            this.setAntrag(offertBase as IRsAntrag);
          } else {
            const rsOffert = offertBase as IRsOffert;
            if (this.offertAntrag) {
              this.setProdukt(rsOffert.Produkt);
            } else {
              this.setOffert(rsOffert);
            }
          }
          this.antragComponent.versicherungsnehmerComponent.setPartner(offertBase.Versicherungsnehmer);
          this.offertComponent.versicherungsnehmerComponent.setPartner(offertBase.Versicherungsnehmer);
        } else {
          window.location.href = data.RedirectUrl;
        }
      },
      (err: HttpErrorResponse) => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.OffertLoad));
        console.log(err.message);
      }
    );
  }

  setProdukt(produkt: IRsProdukt) {
    return new Promise<void>(resolve => {
      this.beginndatum.setValue(moment(produkt.Beginndatum));
      this.paketId.setValue(produkt.PaketId);
      this.fuerWenOptions$.pipe(first()).toPromise().then(res => {
        this.fuerWen.setValue(res.find(x => x.Id === produkt.FuerWenId.toString()));
      });
      this.deckungsumfangErhoehen.setValue(produkt.DeckungsumfangErhoehen ? 'ja' : 'nein');
      this.kennzeichen.setValue(produkt.Kennzeichen);
      this.dataService.zahlungsarten.pipe(first()).toPromise().then((zahlungsarten) => {
        this.zahlungsArtId.setValue(zahlungsarten.find(x => x.Id === produkt.ZahlungArtId.toString()));
      });
      this.ref.detectChanges();
      resolve();
    });
  }

  setAntrag(antrag: IRsAntrag) {
    this.setProdukt(antrag.Produkt).then(() => {
      this.antragComponent.weitereWohneinheiten.setValue(
        antrag.WeitereWohneinheiten === true ? 'ja' : antrag.WeitereWohneinheiten === false ? 'nein' : null);
      if (antrag.ZweiteWohneinheit) {
        this.antragComponent.zweiteWohneinheitComponent.setAdresse(antrag.ZweiteWohneinheit);
      }
      if (antrag.DritteWohneinheit) {
        this.antragComponent.dritteWohneinheitComponent.setAdresse(antrag.DritteWohneinheit);
      }
    });
    this.rsAntragComponent.setRsAntrag(antrag);
    this.antragComponent.setAntrag(antrag);
    this.rsZusammenfassungComponent.besondereAnmerkungenComponent.setValue(antrag.BesondereAnmerkungen);
    this.berufAusschluss.setValue('nein');
  }

  setOffert(offert: IRsOffert): void {
    this.setProdukt(offert.Produkt);
    this.offertComponent.setOffert(offert);
  }

  leistungsuebersichtColumns(pakete: IRsPaket[]): string[] {
    return [
      'name'
    ].concat(Array.from(pakete, x => 'paket' + x.PaketId));
  }

  getProdukt(): IRsProdukt {
    return {
      PaketId: this.paketId.value,
      FuerWenId: this.fuerWen.value ? Number(this.fuerWen.value.Id) : null,
      DeckungsumfangErhoehen: this.deckungsumfangErhoehen.value === 'ja' ? true : false,
      ZahlungArtId: Number(this.zahlungsArtId.value.Id),
      Kennzeichen: this.kennzeichen.value,
      Beginndatum: this.beginndatum.value,
      ExpertMode: this.expertMode
    };
  }

  getOffert(): IRsOffert {
    return {
      ...this.offertComponent.getOffert(),
      Produkt: this.getProdukt()
    } as IRsOffert;
  }

  getAntrag(): IRsAntrag {
    return {
      WeitereWohneinheiten: this.antragComponent.weitereWohneinheiten.value ? this.antragComponent.weitereWohneinheiten.value === 'ja' ? true : false : null,
      ZweiteWohneinheit: this.antragComponent.zweiteWohneinheitComponent.getAdresse(),
      DritteWohneinheit: this.antragComponent.dritteWohneinheitComponent.getAdresse(),
      ...this.rsAntragComponent.getRsAntrag(),
      ...this.antragComponent.getAntrag(),
      AbweichenderVersicherungsort: this.antragComponent.abweichenderVersicherungsort.value ?
        this.antragComponent.abweichenderVersicherungsort.value === 1 ? true : false : null,
      Versicherungsort: this.antragComponent.versicherungsortComponent.getAdresse(),
      BesondereAnmerkungen: this.rsZusammenfassungComponent.besondereAnmerkungen.value,
      Produkt: this.getProdukt()
    } as IRsAntrag;
  }

  getFuerWenOptions() {
    if (this.paketId.value === 1 || this.paketId.value === 2) {
      return this.fuerWenOptions$.pipe(map(options => options.filter(x => x.Key === '3')));
    }
    return this.fuerWenOptions$;
  }

  calculateRate(): void {
    if (this.beginndatum.valid &&
      this.paketId.valid &&
      this.fuerWen.valid &&
      this.deckungsumfangErhoehen.valid) {
      this.calculationService.calculateRsRate(this.getProdukt(), getQuery()).subscribe(
        data => {
          this.rsResult = data;
          this.praemienStatus.setPraemie(Number(this.zahlungsArtId.value.Id), data.Gesamt);
        },
        (err: HttpErrorResponse) => {
          this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.CalculateRate));
          console.log(err.message);
        }
      );
    }
  }
  
  createOffert(): void {
    this.processingService.execute(
      (): boolean => this.firstFormGroup.valid && this.secondFormGroup.valid && this.thirdFormGroup.valid,
      (): Observable<any> => this.offertService.createRsOffert(this.getOffert(), getQuery(),
        this.thirdFormGroupFriendlycaptchaWidgetComponent.getSolution()),
      (data: any): void => {
        this.pdfDataOffert = data;
      },
      (err: HttpErrorResponse): void => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.OffertCreate));
        console.log(err.message);
      }
    );
  }

  createAntrag(): void {
    this.processingService.execute(
      (): boolean => this.firstFormGroup.valid && this.secondFormGroup.valid && this.fourthFormGroup.valid && this.fifthFormGroup.valid,
      (): Observable<any> => this.antragService.createRsAntrag({ ...this.getAntrag(), Eingereicht: false }, getQuery(),
        this.fifthFormGroupFriendlycaptchaWidgetComponent.getSolution()),
      (data: any): void => {
        this.pdfDataAntrag = data;
      },
      (err: HttpErrorResponse): void => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.AntragCreate));
        console.log(err.message);
      }
    );
  }

  verifyOffertLink(): void {
    this.offertService.verifyOffertLink(getQuery()).subscribe(
      (data) => {
        if (data.LinkIsValid === true) {
          this.offertVerificationDialogService.openDialog(data.Privatperson);
        } else {
          this.translateService.get('OFFERTVERIFICATIONLINKEXPIREDINFO').subscribe((text) => {
            this.popupService.openErrorPopup(text);
          });
        }
      },
      (err: HttpErrorResponse) => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.General));
        console.log(err.message);
      }
    );
  }

  onSubmit() {
    this.submitted = true;
  }

  setKuendigungRisiken(kuendigungRisiken: boolean) {
    this.kuendigungRisiken = kuendigungRisiken;
  }

  onValueChanged(): void {
    this.paketId.valueChanges.subscribe(() => {
      this.toggleEditMode();
      this.getFuerWenOptions().pipe(first()).toPromise().then(res => {
        if (this.fuerWen.value && !res.find(x => x.Id === this.fuerWen.value.Id)) {
          this.fuerWen.setValue(null);
        }
      });
    });

    this.deckungsumfangErhoehen
      .valueChanges.subscribe(
        (res) => (this.versicherungssumme = res === 'ja' ? '€ 200.000,-' : '€ 100.000,-')
      );

    merge(
      this.paketId.valueChanges,
      this.deckungsumfangErhoehen.valueChanges
    ).subscribe(() => {
      if (this.getProdukt().PaketId && this.getProdukt().DeckungsumfangErhoehen != null) {
        this.calculationService.getRsPaket(this.getProdukt().PaketId, this.getProdukt().DeckungsumfangErhoehen).subscribe((data) => {
          this.paket = data;
          this.ref.detectChanges();
        });
      }
    });

    merge(
      this.firstFormGroup.valueChanges,
      this.secondFormGroup.valueChanges,
      this.thirdFormGroup.valueChanges,
      this.fourthFormGroup.valueChanges,
      this.fifthFormGroup.valueChanges
    ).subscribe(() => {
      this.resetPdfData();
    });

    // Automatische Berechnung
    valueChanges(this.fb.array([
      this.firstFormGroup,
      this.secondFormGroup
    ])).subscribe(res => {
      if (res.key !== 'kennzeichen') {
        this.calculateRate$.next();
      }
    });
  }

  selectionChange(option: MatListOption) {
    this.paketId.setValue(option.value.PaketId);
  }

  zusammenfassungKorrektur() {
    this.korrektur = true;
  }

  returnZero(): number {
    return 0;
  }
}
